// extracted by mini-css-extract-plugin
module.exports = {"container":"ScrollToTop_container__1fd-M","icon":"ScrollToTop_icon__3G6LO","bounce":"ScrollToTop_bounce__1TgGk"};